import { render, staticRenderFns } from "./AlternativeResultsHint.vue?vue&type=template&id=03c38d96&scoped=true&"
import script from "./AlternativeResultsHint.vue?vue&type=script&lang=js&"
export * from "./AlternativeResultsHint.vue?vue&type=script&lang=js&"
import style0 from "./AlternativeResultsHint.vue?vue&type=style&index=0&id=03c38d96&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c38d96",
  null
  
)

export default component.exports